module.exports = __webpack_public_path__ + "static/img/eiCad_cover_2.f93a9b3d.png";